import { Button, InputText } from "@sellar-io/components";
import { useState } from "react";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useNavigate } from "react-router";
import * as ROUTES from "../../../constants/routes";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useVolumeDiscountsCreate } from "../../../hooks/api/v2/volumeDiscounts/useVolumeDiscountsCreate";

export const VolumeDiscountCreateDialog = ({
  active,
  setActive,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
}) => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [name, setName] = useState("");

  const volumeDiscountCreateMutation = useVolumeDiscountsCreate();

  const onSubmit = () => {
    setError("");

    volumeDiscountCreateMutation.mutate(
      {
        name,
      },
      {
        onSuccess: (res) => {
          setActive(false);
          setName("");
          navigate(ROUTES.VOLUME_DISCOUNT.href({ volumeDiscountId: res.id }));
        },
        onError: (error) => {
          const message =
            apiV2AssertError(error)?.response?.data.message ??
            "Failed to create new volume discount group";
          setError(message);
        },
      },
    );
  };

  const disabled = !name;

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="New volume discount group"
      />
      <DialogContent className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <InputLabel>Name</InputLabel>
          <InputContainer>
            <InputText
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Standard Volume Discounts"
            />
          </InputContainer>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </DialogContent>
      <DialogCTA>
        <Button
          onClick={onSubmit}
          disabled={disabled}
          loading={volumeDiscountCreateMutation.isPending}
        >
          Create
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
